export const MATRIXOS_PRODUCTS = Object.freeze([
  {
    id: "cashup",
    label: "Neo",
    shortLabel: "Neo",
    description: "Workforce operations",
    route: "/neo",
    launchPath: "/neo",
    accent: "blue",
    enabledByDefault: true,
  },
  {
    id: "morpheus",
    label: "Morpheus Count",
    shortLabel: "Morpheus",
    description: "Inventory intelligence",
    route: "/morpheus",
    launchPath: "/morpheus",
    accent: "purple",
    enabledByDefault: false,
  },
  {
    id: "link",
    label: "Link",
    shortLabel: "Link",
    description: "Dispatch coordination",
    route: "/link",
    launchPath: "/link",
    accent: "cyan",
    enabledByDefault: false,
  },
  {
    id: "ontime",
    label: "On Time",
    shortLabel: "On Time",
    description: "Attendance intelligence",
    route: "/ontime",
    launchPath: "/ontime",
    accent: "emerald",
    enabledByDefault: false,
  },
  {
    id: "league",
    label: "Matrix League",
    shortLabel: "League",
    description: "Operational performance competition",
    route: "/league",
    launchPath: "/league",
    accent: "gold",
    enabledByDefault: false,
    requiresOrganization: true,
    provisioning: "first_login",
  },
]);

export function normalizeProductId(value) {
  const id = String(value || "").trim().toLowerCase();
  if (["neo", "admin", "cash-up"].includes(id)) return "cashup";
  if (["mc", "morphius", "morpheus-count"].includes(id)) return "morpheus";
  if (["matrix-league", "matrix_league"].includes(id)) return "league";
  return id;
}

export function productById(value) {
  const id = normalizeProductId(value);
  return MATRIXOS_PRODUCTS.find((product) => product.id === id) || null;
}

export function normalizeEnabledProducts(input) {
  if (Array.isArray(input)) {
    return Array.from(new Set(input.map(normalizeProductId).filter(Boolean)));
  }
  if (input && typeof input === "object") {
    return Object.entries(input)
      .filter(([, enabled]) => enabled === true)
      .map(([id]) => normalizeProductId(id));
  }
  return [];
}

export function getAccessibleProducts({ org = {}, member = {} } = {}) {
  const orgApps = new Set(normalizeEnabledProducts(org.enabledApps || org.apps));
  const memberApps = new Set(
    normalizeEnabledProducts(
      member.enabledApps || member.apps || member.appAccess || member.appsMap
    )
  );

  return MATRIXOS_PRODUCTS.filter((product) => {
    const orgEnabled = product.enabledByDefault || orgApps.has(product.id);
    const memberEnabled = product.enabledByDefault || memberApps.has(product.id);
    return orgEnabled && memberEnabled;
  });
}

export function resolveProductLaunchPath(productId, fallback = "/") {
  return productById(productId)?.launchPath || fallback;
}
